/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "REACTION_DESC" | "REPLIES_DESC" | "%future added value";
export type UnansweredCommentsTabQueryLocal = {
    readonly storyID: string | null;
    readonly storyURL: string | null;
    readonly commentsOrderBy: COMMENT_SORT;
    readonly " $refType": "UnansweredCommentsTabQueryLocal";
};
export type UnansweredCommentsTabQueryLocal$data = UnansweredCommentsTabQueryLocal;
export type UnansweredCommentsTabQueryLocal$key = {
    readonly " $data"?: UnansweredCommentsTabQueryLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"UnansweredCommentsTabQueryLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UnansweredCommentsTabQueryLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storyID",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storyURL",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentsOrderBy",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '8666a05194ed5bd9c74722e48a0a5b7c';
export default node;
